import React, { useEffect, useState } from 'react';
import { Phone, MessageSquare } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FloatingActions = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-219">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.25
    }} className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 flex flex-col gap-3" data-id="element-220">
          {/* Text/SMS Button */}
          <a href="sms:+15597709442" aria-label="Send text message" className="group flex items-center gap-3 bg-brand-black hover:bg-zinc-800 text-white pl-4 pr-5 py-3 rounded-full shadow-2xl border-2 border-white/10 transition-all hover:scale-105" data-id="element-221">
            <div className="relative" data-id="element-222">
              <MessageSquare className="w-5 h-5 text-brand-red" data-id="element-223" />
              <span className="absolute -top-1 -right-1 w-2 h-2 bg-brand-red rounded-full animate-pulse" data-id="element-224" />
            </div>
            <span className="font-oswald font-bold uppercase tracking-wide text-sm hidden sm:inline" data-id="element-225">
              Text Us
            </span>
          </a>

          {/* Call Button */}
          <a href="tel:+15597709442" aria-label="Call (559) 770-9442" className="group flex items-center gap-3 bg-brand-red hover:bg-brand-darkred text-white pl-4 pr-5 py-3 rounded-full shadow-2xl shadow-brand-red/30 border-2 border-white/10 transition-all hover:scale-105 relative" data-id="element-226">
            {/* Pulsing ring */}
            <span className="absolute inset-0 rounded-full bg-brand-red animate-ping opacity-20" data-id="element-227"></span>
            <Phone className="w-5 h-5 relative" data-id="element-228" />
            <span className="font-oswald font-bold uppercase tracking-wide text-sm hidden sm:inline relative" data-id="element-229">
              Call Now
            </span>
          </a>
        </motion.div>}
    </AnimatePresence>;
};